import { PromptRuleChange } from "./getLandlordResearchPromptDiff";
import { PeopleRole, taskForRole } from "../models/peopleCandidate";
import axiosConfig from "./axiosConfig";

// Rule-level + character-level diff between two revisions of a role's people-ranking
// prompt. Mirrors LandlordPromptDiffResponse (reuses the shared PromptRuleChange
// rule-change type); the unified BE echoes the prompt `task`.
export interface PeopleRankingPromptDiffResponse {
  task: string;
  fromRevision: number;
  toRevision: number;
  preambleChanged: boolean;
  // Rule-level diff: which rules moved and which of their fields.
  ruleChanges: PromptRuleChange[];
  // Character-level unified diff of the two compiled prompts.
  textDiff: string[];
}

const getPeopleRankingPromptDiff = async (
  authToken: string,
  role: PeopleRole,
  fromRevision: number,
  toRevision: number
): Promise<PeopleRankingPromptDiffResponse> => {
  const { data } = await axiosConfig.get(`/leads/ai-prompt/diff`, {
    params: { task: taskForRole(role), from: fromRevision, to: toRevision },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getPeopleRankingPromptDiff;
